import { SET_PAGE_BREAK_EACH_BEARING } from "redux/types";

const setPageBreakEachBearing = (payload) => {
    return { type: SET_PAGE_BREAK_EACH_BEARING, payload };
};

export { setPageBreakEachBearing };
